import {  Redirect,Route } from 'react-router-dom';
import React from 'react';


export const PrivateRoute = ({login, component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={props =>
          login ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/auth/sign-in",
              }}
            />
          )
        }
      />
    );
  }